import { render, staticRenderFns } from "./PlansStatsComp.vue?vue&type=template&id=7084a3ae&scoped=true&"
import script from "./PlansStatsComp.vue?vue&type=script&lang=js&"
export * from "./PlansStatsComp.vue?vue&type=script&lang=js&"
import style0 from "./PlansStatsComp.vue?vue&type=style&index=0&id=7084a3ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084a3ae",
  null
  
)

export default component.exports